import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Building2, Phone, Check, Shield, Clock, Key } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_NUMBER = "306-262-5995";

const CommercialPage = () => {
  const services = [
    { title: "Master Key Systems", desc: "One key for management, individual keys for staff. Complete access control." },
    { title: "Access Control Systems", desc: "Electronic access systems with card readers and keypads." },
    { title: "High-Security Locks", desc: "Commercial-grade locks that resist picking, bumping, and drilling." },
    { title: "Panic Bar Installation", desc: "Emergency exit hardware that meets fire codes and safety regulations." },
    { title: "Office Lockouts", desc: "Fast response for business lockouts - minimize downtime." },
    { title: "Safe Services", desc: "Safe installation, combination changes, and emergency openings." },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 px-4 md:px-8 relative">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/279810/pexels-photo-279810.jpeg')] bg-cover bg-center opacity-20"></div>
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 bg-blue-900/80 border border-blue-700 rounded-sm px-6 py-3 mb-6">
            <Building2 className="w-6 h-6 text-amber-400" />
            <span className="text-white font-semibold text-lg">Commercial Services</span>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white mb-6">
            Commercial Locksmith <span className="text-amber-400">Saskatoon</span>
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">
            Protect your business with professional-grade security solutions. From master key systems to advanced access control.
          </p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-lg px-8 py-6">
              <Phone className="w-5 h-5 mr-2" />
              Call Now: {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Our Commercial Services</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, idx) => (
              <div key={idx} className="bg-slate-800 border border-slate-700 rounded-sm p-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-sm flex items-center justify-center mb-4">
                  <Check className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2">{service.title}</h3>
                <p className="text-slate-400">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-20 px-4 md:px-8 bg-slate-800">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-3xl text-white text-center mb-12">Industries We Serve</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {["Offices", "Retail Stores", "Restaurants", "Warehouses", "Medical Facilities", "Schools", "Hotels", "Property Management"].map((industry, idx) => (
              <div key={idx} className="bg-slate-700 rounded-sm p-4 text-center">
                <p className="text-white font-medium">{industry}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 md:px-8 bg-amber-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-3xl text-slate-900 mb-4">Secure Your Business Today</h2>
          <p className="text-slate-700 text-lg mb-8">Free security assessment for your business. Call now!</p>
          <a href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}>
            <Button className="bg-slate-900 hover:bg-slate-800 text-white font-bold text-xl px-10 py-6">
              <Phone className="w-6 h-6 mr-3" />
              {PHONE_NUMBER}
            </Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommercialPage;
